module.exports = __webpack_public_path__ + "static/media/trait-icons-openness.a5c0ddd6.svg";